import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddToCartButton from "../../../components/Storefront/AddToCartButton";
import { CartItem } from "../../../Interfaces/Types";
import { ImprovedParticipant } from "../../../Interfaces/FundraiserRole";

interface ProductActionsProps {
  cartItem: CartItem;
  participant: ImprovedParticipant;
  participantID: string;
  isFromSamplePage?: boolean;
}

const styles = {
  buttonRow: {
    display: "flex",
    gap: "10px", // space between buttons
    marginTop: "10px",
    justifyContent: "space-between",
  },
  continueShopping: {
    width: "30%",
    flex: "end",
  },
};

export const ProductActions: React.FC<ProductActionsProps> = ({
  cartItem,
  participant,
  participantID,
  isFromSamplePage = false,
}) => {
  const navigate = useNavigate();

  const handleContinueShopping = () => {
    if (isFromSamplePage) {
      navigate("/sample-site/participant-shop");
      return;
    }

    navigate(`/improved-participant-shop/part-id/${participantID}`);
  };

  return (
    <div style={styles.buttonRow}>
      <Button
        variant="outlined"
        onClick={() => {
          handleContinueShopping();
        }}
        style={styles.continueShopping}
      >
        Continue Shopping
      </Button>
      <AddToCartButton
        item={cartItem}
        participant={participant}
        isFromSamplePage={isFromSamplePage}
        buttonVariant="contained"
      />
    </div>
  );
};

export default ProductActions;
